import { DISCORD_URL } from 'features/pages/slice';

import {
  Callout,
  Icon,
  LinkWithButtonStyles,
} from '@frontendmentorio/design-system-v2';

export default function CTA() {
  return (
    <div className="px-5 py-8">
      <Callout
        className="container-xl items-center rounded-xl"
        heading="Stay connected"
        theme="light"
      >
        <p className="max-w-prose">
          Join thousands of Frontend Mentor community members taking on
          challenges, sharing resources, helping each other, and chatting about
          all things code.
        </p>

        <LinkWithButtonStyles className="gap-2" href={DISCORD_URL}>
          <Icon name="discord" style="brands" />
          Join our Discord
        </LinkWithButtonStyles>
      </Callout>
    </div>
  );
}
